module.exports = __webpack_public_path__ + "static/img/logoAbftBE.da5b164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logoAbftBE.jpg
// module id = VUr9
// module chunks = 1